exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-wrap[data-v-4ea57bb5]{position:fixed;top:0;right:0;bottom:0;left:0;display:flex;padding:16px;overflow-y:auto}.login-card[data-v-4ea57bb5]{width:100%;max-width:440px;margin:auto;border:0;border-radius:12px;box-shadow:0 12px 32px rgba(0,0,0,.25)}.login-card .card-logo[data-v-4ea57bb5]{position:static;display:block;margin:0 auto 12px}.login-card h1[data-v-4ea57bb5]{font-size:28px!important;font-weight:600}.login-card h2[data-v-4ea57bb5]{font-size:15px;font-weight:400;color:#6c757d}.login-card .login-input[data-v-4ea57bb5]{height:48px;padding:0 14px;font-size:16px}.login-card .login-btn[data-v-4ea57bb5]{padding:12px 16px;font-size:16px;font-weight:600}.login-card .login-remember[data-v-4ea57bb5],.login-small[data-v-4ea57bb5]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/FormLogin.vue?vue&type=style&index=0&id=4ea57bb5&prod&scoped=true&lang=css&
// module id = 876
// module chunks = 0